import React from "react";

interface IAchivements {
  url: string;
  description: string;
}

const Achivements: React.FC = () => {
  const achivements: IAchivements[] = [
    {
      url: "/aboutus/awards/international-aminence-award.png",
      description:
        "Honored with the Customer Service Leadership Award – Committed to Excellence!",
    },
    {
      url: "/aboutus/awards/iso-certificate.png",
      description:
        "Proudly Achieving ISO 9001:2015 Certification – A Mark of Quality and Excellence!",
    },
    {
      url: "/aboutus/awards/iso-service-management.png",
      description:
        "Achieving ISO/IEC 20000-1:2018 Certification – Advancing Excellence in IT Service Management!",
    },
  ];

  return (
    <div className="w-full">
      <div className="flex flex-col justify-center items-center px-5">
        <h3 className="text-xl font-medium sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
          Achievements and Certifications
        </h3>
        <p className="text-sm text-center text-[#090808] pt-2 w-full lg:text-base lg:pt-4 max-w-3xl lg:max-w-3xl xl:text-2xl xl:pt-6">
          Celebrating Milestones and Recognitions That Drive Us Forward
        </p>
      </div>
      <div className="p-5 flex flex-col w-full xl:flex-row justify-center items-center gap-5 md:gap-10 lg:gap-10 xl:gap-20">
        <div className="flex flex-col md:flex-row gap-5 md:gap-10 lg:gap-16 xl:gap-28">
          {achivements.slice(0, 3).map((achivement, index) => {
            return (
              <div
                className="flex flex-col justify-center items-center w-full max-w-[14rem]  gap-5"
                key={index}
              >
                <div>
                  <img
                    src={achivement.url}
                    alt=""
                    className="h-32 sm:h-36 md:h-44 xl:h-64 bg-center"
                  />
                </div>
                <div>
                  <p className="text-xs md:text-sm text-center text-neutral-600">
                    {achivement.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        {/* <div className="flex flex-col md:flex-row gap-5 md:gap-10 lg:gap-16 xl:gap-28">
          {achivements.slice(3).map((achivement, index) => {
            return (
              <div
                className="flex flex-col justify-center items-center w-full max-w-48 gap-5"
                key={index}
              >
                <div>
                  <img
                    src={achivement.url}
                    alt=""
                    className="h-32 sm:h-36 md:h-44 bg-center"
                  />
                </div>
                <div>
                  <p className="text-xs text-center text-neutral-600">
                    {achivement.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div> */}
      </div>
    </div>
  );
};

export default Achivements;
